import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"

export type IconeFAProps = {
    icone: IconProp
    onClick?: () => void
    style?:React.CSSProperties
}

export const IconeFA = (props: IconeFAProps) => {
    return <i className="_mx-1" style={props.style}
        id="IconeFa_Marcador"
        >
        <a className="_text-blue-700" href={"#"} onClick={e => {
            e.preventDefault()
            props.onClick?.()
        }}>
            <FontAwesomeIcon icon={props.icone}/>
        </a>
    </i>
}